function path(root: string, subLink: string) {
  return `${root}${subLink}`;
}

const ROOTS_AUTH = '/authentication';
const ROOTS_DASHBOARD = '/dashboard';
const ROOTS_WEB_APP = process.env.REACT_APP_WEB_APP_LINK;

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
};

export const PATH_ERRORS = {
  notFound: '/404',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  overview: path(ROOTS_DASHBOARD, '/overview'),
  profile: path(ROOTS_DASHBOARD, '/profile'),
  language: path(ROOTS_DASHBOARD, '/language'),
  users: {
    root: path(ROOTS_DASHBOARD, '/users'),
    list: path(ROOTS_DASHBOARD, '/users/list'),
    create: path(ROOTS_DASHBOARD, '/users/create'),
  },
  speakers: {
    root: path(ROOTS_DASHBOARD, '/speaker-singer'),
    list: path(ROOTS_DASHBOARD, '/speaker-singer/list'),
    create: path(ROOTS_DASHBOARD, '/speaker-singer/create'),
  },
  heyats: {
    root: path(ROOTS_DASHBOARD, '/heyats'),
    list: path(ROOTS_DASHBOARD, '/heyats/list'),
    create: path(ROOTS_DASHBOARD, '/heyats/create'),
    profile: path(ROOTS_DASHBOARD, '/heyats/profile'),
    archive: path(ROOTS_DASHBOARD, '/heyats/archive'),
    live: path(ROOTS_DASHBOARD, '/heyats/live'),
  },
  occasions: {
    root: path(ROOTS_DASHBOARD, '/occasions'),
    list: path(ROOTS_DASHBOARD, '/occasions/list'),
    create: path(ROOTS_DASHBOARD, '/occasions/create'),
  },
  harams: {
    root: path(ROOTS_DASHBOARD, '/harams'),
    list: path(ROOTS_DASHBOARD, '/harams/list'),
    create: path(ROOTS_DASHBOARD, '/harams/create'),
  },
  qurans: {
    root: path(ROOTS_DASHBOARD, '/qurans'),
    list: path(ROOTS_DASHBOARD, '/qurans/list'),
    create: path(ROOTS_DASHBOARD, '/qurans/create'),
  },
  conversations: {
    root: path(ROOTS_DASHBOARD, '/conversations'),
    list: path(ROOTS_DASHBOARD, '/conversations/list'),
    create: path(ROOTS_DASHBOARD, '/conversations/create'),
    messages: path(ROOTS_DASHBOARD, '/conversations/:id/messages'),
  },
  blog: {
    root: path(ROOTS_DASHBOARD, '/blog'),
    list: path(ROOTS_DASHBOARD, '/blog/list'),
    create: path(ROOTS_DASHBOARD, '/blog/create'),
    categoryRoot: path(ROOTS_DASHBOARD, '/blog/category'),
    categoryList: path(ROOTS_DASHBOARD, '/blog/category/list'),
    categoryCreate: path(ROOTS_DASHBOARD, '/blog/category/create'),
  },
  news: {
    root: path(ROOTS_DASHBOARD, '/news'),
    list: path(ROOTS_DASHBOARD, '/news/list'),
    create: path(ROOTS_DASHBOARD, '/news/create'),
    categoryRoot: path(ROOTS_DASHBOARD, '/news/category'),
    categoryList: path(ROOTS_DASHBOARD, '/news/category/list'),
    categoryCreate: path(ROOTS_DASHBOARD, '/news/category/create'),
  },
  contactUs: {
    root: path(ROOTS_DASHBOARD, '/contactUs'),
    list: path(ROOTS_DASHBOARD, '/contactUs/list'),
  },
  reports: {
    root: path(ROOTS_DASHBOARD, '/reports'),
    list: path(ROOTS_DASHBOARD, '/reports/list'),
  },
  sliders: {
    root: path(ROOTS_DASHBOARD, '/sliders'),
    list: path(ROOTS_DASHBOARD, '/sliders/list'),
    create: path(ROOTS_DASHBOARD, '/sliders/create'),
  },
  pages: {
    root: path(ROOTS_DASHBOARD, '/pages'),
    list: path(ROOTS_DASHBOARD, '/pages/list'),
  },
  gallery: {
    root: path(ROOTS_DASHBOARD, '/gallery'),
    list: path(ROOTS_DASHBOARD, '/gallery/list'),
  },
  server: {
    root: path(ROOTS_DASHBOARD, '/server'),
  },
  theme: {
    root: path(ROOTS_DASHBOARD, '/theme'),
  },
  notifications: {
    root: path(ROOTS_DASHBOARD, '/notifications'),
    list: path(ROOTS_DASHBOARD, '/notifications/list'),
    create: path(ROOTS_DASHBOARD, '/notifications/create'),
  },
  archive: {
    root: path(ROOTS_DASHBOARD, '/archive'),
    list: path(ROOTS_DASHBOARD, '/archive/list'),
  },
  advertisement: {
    root: path(ROOTS_DASHBOARD, '/advertisements'),
    list: path(ROOTS_DASHBOARD, '/advertisements/list'),
  },
  liveProgram: {
    root: path(ROOTS_DASHBOARD, '/live-program'),
    list: path(ROOTS_DASHBOARD, '/live-program/list'),
  },
  config: {
    root: path(ROOTS_DASHBOARD, '/config'),
    list: path(ROOTS_DASHBOARD, '/config/list'),
    create: path(ROOTS_DASHBOARD, '/config/create'),
  },
  tags: {
    root: path(ROOTS_DASHBOARD, '/tags'),
    list: path(ROOTS_DASHBOARD, '/tags/list'),
    create: path(ROOTS_DASHBOARD, '/tags/create'),
  },
  faq: {
    root: path(ROOTS_DASHBOARD, '/faq'),
    list: path(ROOTS_DASHBOARD, '/faq/list'),
    create: path(ROOTS_DASHBOARD, '/faq/create'),
  },
};

export const PATH_WEB_APP = {
  root: ROOTS_WEB_APP,
  news: path(ROOTS_WEB_APP, '/news'),
  haramOnline: path(ROOTS_WEB_APP, '/haram-online'),
  quranOnline: path(ROOTS_WEB_APP, '/quran-online'),
  speakerSinger: path(ROOTS_WEB_APP, '/speaker-singer'),
};
